import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/ProtectedRoute'
import Login from './pages/Login'
import AdminLayout from './components/AdminLayout'
import Dashboard from './pages/Dashboard'
import Users from './pages/Users'
import YogaSchools from './pages/YogaSchools'
import YogaSchoolDetail from './pages/YogaSchoolDetail'
import UploadSchoolDocuments from './pages/UploadSchoolDocuments'
import Courses from './pages/Courses'
import CourseDetail from './pages/CourseDetail'
import AddCourse from './pages/AddCourse'
import Applications from './pages/Applications'
import Testimonials from './pages/Testimonials'
import FAQs from './pages/FAQs'
import Consultations from './pages/Consultations'
import Analytics from './pages/Analytics'
import Settings from './pages/Settings'
import CommissionSettings from './pages/CommissionSettings'
import SchoolRegistrations from './pages/SchoolRegistrations'
import OnboardSchool from './pages/OnboardSchool'
import AdminUsers from './pages/AdminUsers'

function App() {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-ivory-50">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="yoga-schools" element={<YogaSchools />} />
            <Route path="yoga-schools/:schoolId" element={<YogaSchoolDetail />} />
            <Route path="yoga-schools/:schoolId/verification-documents" element={<UploadSchoolDocuments />} />
            <Route path="onboard-school" element={<OnboardSchool />} />
            <Route path="registrations" element={<SchoolRegistrations />} />
            <Route path="courses" element={<Courses />} />
            <Route path="courses/new" element={<AddCourse />} />
            <Route path="courses/:courseId" element={<CourseDetail />} />
            <Route path="bookings" element={<Applications />} />
            <Route path="testimonials" element={<Testimonials />} />
            <Route path="faqs" element={<FAQs />} />
            <Route path="consultations" element={<Consultations />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="settings" element={<Settings />} />
            <Route path="commission-settings" element={<CommissionSettings />} />
            <Route path="admin-users" element={<AdminUsers />} />
          </Route>
          <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/courses" element={<Navigate to="/admin/courses" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  )
}

export default App

